import { NOTIFICATIONS } from '../actionTypes';

export const setNotifyParams = data => ({
  type: NOTIFICATIONS.SET_STATUS_AND_TYPE,
  payload: {
    data
  }
});
